module.exports = function() {
  return new Worker(__webpack_public_path__ + "093514d9b57b4361cd1b.worker.js");
};